module.exports = __webpack_public_path__ + "img/KM.24874b3c.svg";